import { ROLES } from '../constants/roles';

type PlayRow = { listerId?: string };
type Viewer = { id?: string; role?: string };

/**
 * Listers see only their own plays; bankers and other house roles see the full ledger.
 */
export function filterPlaysForViewer<T extends PlayRow>(plays: T[], viewer: Viewer | null | undefined): T[] {
  if (!Array.isArray(plays)) return [];
  if (viewer?.role === ROLES.LISTER && viewer.id) {
    return plays.filter((play) => play.listerId === viewer.id);
  }
  return plays;
}
